module.exports = __webpack_public_path__ + "media/images/camp_geer_image_2-c05132bf6bdd1bf33456d1850987edce.jpg";